// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3XXN7","image":"Header_image__18YAT","name":"Header_name__1aenf","info":"Header_info__34exm","infoRow":"Header_infoRow__2pq0i"};